module.exports = __webpack_public_path__ + "static/img/laboratory2.916c0c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laboratory2.jpg
// module id = NlCm
// module chunks = 1